import { PropsWithChildren, ReactNode } from 'react';
import { Flex, FormSectionGrid, IconName, Paragraph } from '../../atoms';
import { SquareIconHeading } from '../../molecules';

type ProductSectionCardProps = PropsWithChildren<{
  cardTitle: string;
  iconName?: IconName;
  checkBox?: ReactNode;
  cardSubTitle?: string;
  isOptional?: boolean;
  extraLabel?: string;
}>;

export function ConfigCardSection({
  children,
  cardTitle,
  iconName,
  checkBox,
  cardSubTitle,
  isOptional = false,
  extraLabel
}: ProductSectionCardProps): JSX.Element {
  return (
    <Flex
      as="section"
      w="100%"
      borderRadius="radii.x2"
      borderColor="palette_blue.0"
      borderWidth="2px"
      p="space_unit.x4"
      flexDir="column"
      mb="space_unit.x4"
    >
      <SquareIconHeading
        title={cardTitle}
        iconName={iconName}
        isOptional={isOptional}
        extraLabel={extraLabel}
      />

      {cardSubTitle && (
        <Paragraph my="space_unit.x2" size="sm" color="palette_gray.60">
          {cardSubTitle}
        </Paragraph>
      )}

      <FormSectionGrid
        alignItems="end"
        templateRows="auto"
        templateColumns="repeat(2,50%)"
      >
        {children}
      </FormSectionGrid>
      {checkBox && checkBox}
    </Flex>
  );
}
